import DOMPurify from 'dompurify';
import { getRoomContentText } from '../../../../lib/Room';
import { RoomStructureContent } from '../../../../definitions/schemas';
import ContentType from '../../../../enums/ContentType';
import { StorageProviderMTPickers } from '../../../../enums/Integrations/StorageProviders';

export const getContentDescription = (
  structureContent: RoomStructureContent,
  isInlineIframeViewerEnabled: boolean
): [string, boolean] => {
  const {
    description,
    descriptionVisible = false,
    match: content,
  } = structureContent;

  // Force hiding the name and description for URLs
  // to avoid depending on the structure flags
  const isUrl = content.type === ContentType.URL;
  const isAssetHubContent =
    content.mtData?.provider === StorageProviderMTPickers.AssetHub;

  const contentDescription = DOMPurify.sanitize(
    getRoomContentText(description, content.description),
    { USE_PROFILES: { html: false }, KEEP_CONTENT: true }
  );
  const displayDescription =
    descriptionVisible &&
    ((isAssetHubContent && isInlineIframeViewerEnabled) ||
      (!isUrl && contentDescription !== ''));

  return [contentDescription, displayDescription];
};

export const getContentName = (
  structureContent: RoomStructureContent,
  isInlineIframeViewerEnabled: boolean
): [string, boolean] => {
  const { name, nameVisible = false, match: content } = structureContent;

  // Force hiding the name and name for URLs
  // to avoid depending on the structure flags
  const isUrl = content.type === ContentType.URL;
  const isAssetHubContent =
    content.mtData?.provider === StorageProviderMTPickers.AssetHub;

  const contentName = getRoomContentText(name, content.name);
  const displayName =
    nameVisible &&
    ((isAssetHubContent && isInlineIframeViewerEnabled) ||
      (!isUrl && contentName !== ''));

  return [contentName, displayName];
};
